import { useInfiniteQuery } from "@tanstack/react-query";
import collectionApiClient, { CollectionOrder } from "../../../api/collection";

const useCollectionOrdersQuery = (
  textSearch: string = "",
  limit: number = 20,
  sort?: Record<string, 1 | -1>,
) => {
  const fetchOrders = async (
    pageParam: {
      skip?: number;
      limit?: number;
    },
    query: string,
  ): Promise<CollectionOrder[]> => {
    const { skip = 0, limit: pageLimit = limit } = pageParam;
    return await collectionApiClient.getCollectionOrders({
      query,
      skip,
      limit: pageLimit,
      sort,
    });
  };

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, ...rest } =
    useInfiniteQuery<CollectionOrder[], Error>({
      queryKey: ["collection-orders", textSearch, limit, sort],
      queryFn: ({ pageParam }) =>
        fetchOrders({ ...(pageParam ?? { skip: 0, limit }) }, textSearch),
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < limit) {
          return undefined;
        }
        const totalFetched = allPages.reduce(
          (acc, page) => acc + page.length,
          0,
        );
        return { skip: totalFetched, limit };
      },
      initialPageParam: { skip: 0, limit },
    });

  return {
    data: data?.pages.flat() || [],
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ...rest,
  };
};

export default useCollectionOrdersQuery;
